import cx from 'classnames';
import { h } from 'preact';

import Portal from './Portal';

interface Props {
  class: string;
  tooltipRef(any): void;
  style?: { [key: string]: string };
  isHidden?: boolean;
}

function Tooltip({ class: cls, style, isHidden, tooltipRef }: Props) {
  const klass = cx(cls, { 'display-none': isHidden });

  return (
    <Portal>
      <div class={klass} style={style} ref={tooltipRef}>
        {this.props.children}
      </div>
    </Portal>
  );
}

Tooltip.defaultProps = {
  class: 'tooltip',
  isHidden: false,
};

export default Tooltip;
